(function() {
    'use strict';

    angular.module('product')
        .controller('ProductOptionCreateController', ProductOptionCreateController);

    ProductOptionCreateController.$inject = ['$state', 'notificationSrvc', 'productOptionDataSrvc', 'productOptionMessagesConst', 'productOptionGroupDataSrvc', 'productOptionTechLineDataSrvc', 'techlinePermissionsConst', 'checkModelPermissionsSrvc', 'errorNotificationSrvc'];

    function ProductOptionCreateController($state, notificationSrvc, productOptionDataSrvc, productOptionMessagesConst, productOptionGroupDataSrvc, productOptionTechLineDataSrvc, techlinePermissionsConst, checkModelPermissionsSrvc, errorNotificationSrvc) {
        var self = this;

        self.serverErrors = {
            label_pl: [],
            label_en: [],
            label_de: [],
            label_cpde: [],
            label_cpen: [],
            description_pl: [],
            description_de: [],
            description_en: [],
            description_cpde: [],
            description_cpen: [],
            thickness: [],
            hidden_price: [],
            realization_days: [],
            enter_values_possible: [],
            group_together: [],
            tech_line: [],
            confirm_choice: [],
            show_on_production: [],
            statement_pl: [],
            statement_de: [],
            statement_en: [],
            statement_cpde: [],
            statement_cpen: [],
            options_group: [],
            show_in_inteligent_filter: [],
            image: [],
            applies_to_custom_format: [],
            custom_format_dimension: [],
            internal_description: [],
            nonFieldErrors: []
        };
        self.optionData = {
            label_pl: '',
            label_en: '',
            label_de: '',
            label_cpde: '',
            label_cpen: '',
            description_pl: '',
            description_de: '',
            description_en: '',
            description_cpde: '',
            description_cpen: '',
            thickness: '',
            hidden_price: false,
            realization_days: '',
            enter_values_possible: false,
            group_together: false,
            tech_line: false,
            confirm_choice: false,
            show_on_production: false,
            min_value: 0,
            max_value: 0,
            options_group: $state.params.pk,
            show_in_inteligent_filter: false,
            image: null,
            applies_to_custom_format: false,
            custom_format_dimension: null,
            internal_description: ''
        };

        self.techLineObjectServerErrors = {
            start_x: [],
            start_y: [],
            end_x: [],
            end_y: [],
            image: []
        };
        self.techLineObjectData = {
            start_x: 0.0,
            start_y: 0.0,
            end_x: 0.0,
            end_y: 0.0,
            image: undefined
        };

        self.customFormatDimensionChoices = [];

        self.hasTechLineAddPermission = hasTechLineAddPermission;
        self.hasTechLineViewPermission = hasTechLineViewPermission;

        self.createOption = createOption;
        self.cleanErrors = cleanErrors;

        self.onAppliesToCustomFormatChange = onAppliesToCustomFormatChange;
        self.onEnterValuesPossibleChange = onEnterValuesPossibleChange;

        activate();

        function activate() {
            getGroupName($state.params.pk);
            getCustomFormatDimensionChoices();
        }

        function hasTechLineAddPermission() {
            return !checkModelPermissionsSrvc.isDenied(
                techlinePermissionsConst.add);
        }

        function hasTechLineViewPermission() {
            return !checkModelPermissionsSrvc.isDenied(
                techlinePermissionsConst.view);
        }

        function createOption() {
            productOptionDataSrvc.create(
                self.optionData
            ).$promise.then(
                function(response) {
                    if (!hasTechLineAddPermission()) {
                        notificationSrvc.notification("error", techlinePermissionsConst.add.errorMsg);
                        return;
                    }

                    self.techLineObjectData.option = response.pk;
                    productOptionTechLineDataSrvc.create(
                        self.techLineObjectData
                    ).$promise.then(
                        function(techLineResponse) {
                            notificationSrvc.notification("success", productOptionMessagesConst.add);
                            $state.go('layout.productOptionGroup.detail', { pk: $state.params.pk });
                        },
                        function(response) {
                            errorNotificationSrvc.displayErrors(response.data);
                            self.techLineObjectServerErrors = response.data;
                        }
                    );
                },
                function(response) {
                    errorNotificationSrvc.displayErrors(response.data);
                    self.serverErrors = response.data;
                }
            );
        }

        function getGroupName(pk) {
            return productOptionGroupDataSrvc.get({
                pk: pk
            }).$promise.then(function(response) {
                self.groupName = response.name_pl;
            });
        }

        function cleanErrors(object, key) {
            object[key] = [];
        }

        function getCustomFormatDimensionChoices() {
            productOptionDataSrvc.adminKindOptions().$promise.then(
                function (response) {
                    self.customFormatDimensionChoices = response;
                }
            );
        }

        function onAppliesToCustomFormatChange() {
            self.optionData.custom_format_dimension = null;
        }

        function onEnterValuesPossibleChange() {
            self.optionData.applies_to_custom_format = false;
            self.optionData.custom_format_dimension = null;
        }
    }
})();
